import { render, staticRenderFns } from "./gallery-pictures.vue?vue&type=template&id=1f99bc4a&scoped=true&"
import script from "./gallery-pictures.vue?vue&type=script&lang=js&"
export * from "./gallery-pictures.vue?vue&type=script&lang=js&"
import style0 from "./gallery-pictures.vue?vue&type=style&index=0&id=1f99bc4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f99bc4a",
  null
  
)

export default component.exports